/**
 * Report mode builds lists from page data. Analytical questions belong in Ask.
 */

const LIST_PATTERNS = [
  /\b(list|show me all|all cards|cards in|cards with|cards where|unassigned|missing target|no target date|without target|assigned to|in building|in reviewing|in testing|fetch error|metrics with|how many|count of)\b/i,
  /^(list|show me|give me a list|print)\b/i,
];

const ASK_PATTERNS = [
  /\bhow (will|could|might|would|do|can|should)\b/i,
  /\bwhy\b/i,
  /\bwhat (does|will|would|are the implications)\b/i,
  /\b(anticipat|impact|affect|implications|explain|mean for|compared to|versus)\b/i,
  /\b(desert|shortage|access gap)\b/i,
  /\bhr\s*-?\s*1\b/i,
  /\bchanging with\b/i,
  /\bwhat if\b/i,
];

export function shouldSuggestAskForReport (question) {
  const q = (question || '').trim();
  if (q.length < 24) return false;

  const askHit = ASK_PATTERNS.some((re) => re.test(q));
  if (!askHit) return false;

  const listHit = LIST_PATTERNS.some((re) => re.test(q));
  if (listHit && !/\bhow (will|could|might|can)\b/i.test(q)) {
    return false;
  }

  return true;
}
